var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xh-wrap"
  }, [_c('myImg', {
    attrs: {
      "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/banner3_1.jpg"
    }
  }), _vm._v(" "), _c('myTab', {
    attrs: {
      "tab-list": _vm.tabList,
      "activeIndex": _vm.activeIndex,
      "bread-title": _vm.breadTitle,
      "smallSize": ""
    },
    on: {
      "change": _vm.changeTab
    }
  }), _vm._v(" "), (_vm.activeIndex == 0 && !_vm.videoDetail && !_vm.imgDetail.length) ? [_c('b-container', [_c('b-row', _vm._l((_vm.imgList), function(v, i) {
    return _c('b-col', {
      key: i,
      attrs: {
        "md": "6",
        "lg": "4"
      }
    }, [(i < 9) ? _c('div', {
      staticClass: "item mt-40 text-center",
      on: {
        "click": function($event) {
          return _vm.handleShowImgDetail(v)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": v.img,
        "height": "230px",
        "alt": v.alt
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "mt-20  color-fff fs-24"
    }, [_vm._v(_vm._s(v.title))])]) : _vm._e()])
  }), 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.activeIndex == 1 && !_vm.videoDetail && !_vm.imgDetail.length) ? [_c('b-container', [_c('b-row', _vm._l((_vm.mockVideoList), function(v, i) {
    return _c('b-col', {
      key: i,
      attrs: {
        "md": "6",
        "lg": "4"
      }
    }, [(i < 9) ? _c('div', {
      staticClass: "item mt-40 text-center",
      on: {
        "click": function($event) {
          return _vm.handleShowVideoDetail(v)
        }
      }
    }, [_c('div', {
      staticClass: "img-wrap pr"
    }, [_c('img', {
      attrs: {
        "src": v.poster,
        "height": "230px",
        "alt": v.alt
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "pa icon",
      attrs: {
        "src": "@/assets/img/icon_play.png"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "overlay"
    })]), _vm._v(" "), _c('div', {
      staticClass: "mt-20  color-fff fs-24"
    }, [_vm._v(_vm._s(v.title))])]) : _vm._e()])
  }), 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.videoDetail) ? [_c('div', {
    staticClass: "container text-center"
  }, [_c('div', {
    staticClass: "fs-24 bold color-fff mt-60 mb-30"
  }, [_vm._v("\n        " + _vm._s(_vm.videoDetail.title) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "fs-14 color-ccc mb-40"
  }, [_vm._v(_vm._s(_vm.videoDetail.desc))]), _vm._v(" "), _c('video', {
    staticClass: "mb-60",
    attrs: {
      "controls": "",
      "src": _vm.videoDetail.src
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.imgDetail.length) ? [_c('b-container', {
    staticClass: "mb-40"
  }, [_c('b-row', _vm._l((_vm.imgDetail), function(v, i) {
    return _c('b-col', {
      key: i,
      attrs: {
        "md": "6",
        "lg": "4"
      }
    }, [_c('div', {
      staticClass: "item mt-40 "
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (v.img),
        expression: "v.img"
      }],
      attrs: {
        "height": "230px"
      }
    })])])
  }), 1)], 1)] : _vm._e(), _vm._v(" "), (!_vm.videoDetail && !_vm.imgDetail.length) ? _c('div', {
    staticClass: "container text-center mt-30 mb-30"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.total,
      "page": _vm.pageNo,
      "limit": 9
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('page-Footer')], 2)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ef3a57c","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/history/index.vue
// module id = null
// module chunks = 